import {
  isAllowlistedEmptyNodeName,
  isParsedHtmlElement,
  uniqueIdentifierForNode,
} from '@ctw/shared/utils/cda/helpers';
import type { CdaParsedHtmlNode } from '@ctw/shared/utils/cda/types';
import { memo, type ReactNode } from 'react';
import { ReactNodeRenderer } from './react-node-renderer';

interface ReactHtmlRendererProps {
  id: string;
  emptyState?: ReactNode;
  htmlString?: never;
  parsedHtmlNodes: Array<CdaParsedHtmlNode>;
}

export const ReactHtmlRenderer = memo(
  ({ id, parsedHtmlNodes, emptyState }: ReactHtmlRendererProps) => {
    const isNodeWithoutContent = (node: CdaParsedHtmlNode) =>
      node.isEffectivelyEmpty &&
      !(isParsedHtmlElement(node) && isAllowlistedEmptyNodeName(node.nodeName));

    if (parsedHtmlNodes.every(isNodeWithoutContent)) {
      return emptyState ?? null;
    }

    return (
      <>
        {parsedHtmlNodes.map((node, index) => {
          const nodeIdentifier = uniqueIdentifierForNode({
            node: node,
            index,
            context: id,
            purpose: 'html-child',
          });

          return <ReactNodeRenderer id={nodeIdentifier} key={nodeIdentifier} node={node} />;
        })}
      </>
    );
  },
);
